import React, {useEffect, useState, useRef} from 'react';
import {Container, Spinner, Alert} from 'reactstrap';
import './login.scss'
import {useTranslation, Trans} from 'react-i18next';
import Button from "../../components/Button/Button";
import '../../assets/styles/colors.scss';
import {authenticate, loginExternalUser, providers} from '../../store/actions/auth.actions'
import {useDispatch, useSelector} from 'react-redux';
import {useForm} from 'react-hook-form';
import {LoginSchema, RegisterSchema} from '../../utils/validationSchemas';
import {yupResolver} from '@hookform/resolvers/yup';
import {Redirect} from 'react-router-dom';
import {Link} from "react-router-dom";
import {Badge, Modal, ModalHeader, ModalBody} from 'reactstrap';
import {handleRegister} from '../../store/actions/register.actions';
import FacebookLogin from 'react-facebook-login';
import {LinkedIn} from 'react-linkedin-login-oauth2';
import axios from '../../config/axios-interceptor';
import {getCountries, getSectors} from "../../store/actions/app.actions";

const Login = () => {

    const boothPackages = {
        platinium: 1,
        premium: 2,
        standard: 3
    }

    const dispatch = useDispatch()
    const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);
    const errorMessage = useSelector((state) => state.auth.errorMessage);
    const isLoading = useSelector((state) => state.auth.isLoading);
    const countries = useSelector((state) => state.app.countries);
    const sectors = useSelector((state) => state.app.sectors);
    const [boothPreference, setBoothPreference] = useState<number>(-1)

    const [visitor, setVisitor] = useState(true);
    const [successModal, setSuccessModal] = useState(false);
    const message = useSelector((state) => state.register.message);

    const currentUrl = window.location.host

    const [registerModal, setRegisterModal] = useState(false);
    const toggleRegisterModal = () => setRegisterModal(!registerModal);

    const [forgetModal, setForgetModal] = useState(false);
    const toggleForgetModal = () => setForgetModal(!forgetModal);

    const [forgetPassEmail, setForgetPassEmail] = useState('');

    const handleEmailOnChange = (e) => setForgetPassEmail(e.target.value);

    const {t} = useTranslation();

    useEffect(() => {
        dispatch(providers());
        dispatch(getCountries());
        dispatch(getSectors())
    }, []);

    const {register, handleSubmit, errors, setValue} = useForm({
        resolver: yupResolver(LoginSchema)
    });

    const {
        register: registerForm,
        handleSubmit: handleSubmitRegister,
        errors: registerErrors,
        setValue: setRegisterValue
    } = useForm({
        resolver: yupResolver(RegisterSchema)
    });

    const handleLogin = async (data) => {
        const body = {
            email: data.email,
            password: data.password
        }
        dispatch(authenticate(body));
    }

    const handleRegisterApi = async (data) => {
        const body = {
            ...data,
            visitor: visitor,
            packageId: boothPreference
        }
        dispatch(handleRegister(body));
        toggleRegisterModal();
    }

    const responseFacebook = (response) => {
        const body = {
            loginProvider: 'Facebook',
            userName: response.email,
            email: response.email,
            name: response.name,
            accessToken: response.accessToken
        };
        dispatch(loginExternalUser(body))
    }

    const handleSuccess = (data) => {
        const body = {
            loginProvider: 'LinkedIn',
            userName: "noemail@email.com",
            email: "noemail@email.com",
            name: "noname",
            accessToken: data.code
        };
        dispatch(loginExternalUser(body))
    }

    const handleFailure = (error) => {
        // console.log('fail: ', error)
    }


    const style = {boxShadow: '0px 0px 10px 0px #80C32D', border: '2px solid #80C32D', borderRadius: '6px'};

    const handleForgetPassword = async () => {
        try {
            const res = await axios.post('Account/forgot-password', {email: forgetPassEmail});
            if(res.status === 200) {
                toggleForgetModal();
                alert('Check your email for new password!');
            }
        }
        catch(error) {
            console.log(error);
        }
    }

    return (
        <div className="login-background">
            <div className="overlay-effect pb-4">
                <Container className="pt-4">
                    <div className="py-5 text-center bg-white mx-auto px-2 px-md-0" style={{maxWidth: '600px'}}>
                        <img className="img-fluid" src={require('../../assets/images/logo.png')}/>

                        <h3 style={{color: '#a88b6b'}}
                            className="pt-5 pb-4 font-weight-lighter">{t('loginWelcome')}</h3>

                        <form>
                            <div className="mb-2 mx-auto w-100" style={{maxWidth: '350px'}}>
                                <input
                                    className="login-input w-100 px-3 py-2 mb-2"
                                    ref={register} name="email"
                                    onChange={e => setValue('email', e.currentTarget.value)}
                                    placeholder={t('eMailField')}
                                    type='text'
                                />
                                {errors.email &&
                                <div className="text-danger text-left small mx-2">{errors.email.message}</div>}
                            </div>

                            <div className="mx-auto w-100" style={{maxWidth: '350px'}}>
                                <input
                                    className="login-input w-100 px-3 py-2 mb-2"
                                    ref={register} name="password"
                                    onChange={e => setValue('password', e.currentTarget.value)}
                                    placeholder={t('passwordField')}
                                    type='password'
                                />
                                {errors.password &&
                                <div className="text-danger text-left small mx-2 mb-2">{errors.password.message}</div>}
                            </div>
                        </form>

                        <Modal isOpen={forgetModal} toggle={toggleForgetModal} contentClassName="border-0"
                               style={{boxShadow: '0px 0px 10px 0px #80C32D', border: '2px solid #80C32D', borderRadius: '6px'}}>
                            <ModalBody className="pb-3 pt-5">
                                <p style={{marginLeft: '58px', color:'#80c32d' }}className="small">{t('loginModalTxt')}</p>
                                <div className="text-center">
                                    <div className="mb-2 mx-auto w-100" style={{maxWidth: '350px'}}>
                                    <input
                                        className="login-input w-100 px-3 py-2 mb-2"
                                        ref={register} name="emaill"
                                        onChange={handleEmailOnChange}
                                        placeholder={t('eMailField')}
                                        type='email'
                                    />
                                        {errors.email &&
                                        <div className="text-danger text-left small mx-2">{errors.email.message}</div>}
                                </div>
                                </div>
                                <Button onClick={handleForgetPassword} className="float-right" type="grayTransparent" text={t('btnResetPass')}></Button>
                            </ModalBody>
                        </Modal>
                        <div className="border-0 pt-2">
                            <p onClick={toggleForgetModal} style={{color: '#b6b6b6', cursor: 'pointer'}} className="small">
                                {t('forgotPassTxt')}
                            </p>
                        {/*// style={{color: '#a88b6b'}}>këtu</Link>*/}
                        {/*<p style={{color:'#b6b6b6'}} className="small">*/}
                        {/*  <Trans i18nKey="loginText1">*/}
                        {/*    Nëse nuk keni llogari, mund të regjistroheni <Link to="/" style={{color:'#a88b6b'}}>këtu</Link>*/}
                        {/*  </Trans>*/}
                        {/*</p>*/}

                        </div>
                            <button
                                onClick={handleSubmit(handleLogin)}
                                className="border-0 w-100 text-white font-weight-bold"
                                style={{
                                    padding: '10px 36px', width: '100%', maxWidth: '230px', background: '#a88b6b',
                                    borderRadius: '100px', marginTop: '10px'
                                }}
                            >
                                {isLoading ? <Spinner/> : t('loginBtn1')}
                            </button>


                        <div>

                            <div className="border-0 pt-5">
                                {/* <p style={{color: '#b6b6b6'}} className="small">
                                    <Trans i18nKey="loginText1">
                                        Nëse nuk keni llogari, mund të regjistroheni
                                        <Link to="/"
                                              style={{color: '#a88b6b'}}>këtu</Link>
                                    </Trans>
                                </p> */}
                                <Button onClick={toggleRegisterModal} text="REGISTER"
                                        className="border-0 text-white text-center font-weight-bold mb-3"
                                        style={{
                                            padding: '10px 36px',
                                            width: '70%',
                                            maxWidth: '150px',
                                            background: '#6b5841',
                                            borderRadius: '100px'
                                        }}/>
                            </div>

                        </div>
                        <div className="text">
                            <Modal isOpen={registerModal} toggle={toggleRegisterModal}
                                   contentClassName={`border-0 ${!successModal ? "modal-content-register" : ""}`}
                                    style={successModal ? {...style} : {}}>
                                <ModalHeader toggle={toggleRegisterModal} style={{border: 'none'}}></ModalHeader>
                                <ModalBody className="pb-2 ml-3 pt-0 mr-4">
                                    {successModal ?
                                        <h2 className="text-center">{message}</h2>
                                    : <>
                                        <div className="text-center mb-3">
                                            <img className="img-fluid" src={require('../../assets/images/logo.png')}/>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-2 mx-auto pl-3 mb-3">
                                                {/*<Button*/}
                                                {/*    text={t("businessBtn")}*/}
                                                {/*    type="successTransparent"*/}
                                                {/*    className="mt-4 mr-3"*/}
                                                {/*    style={{backgroundColor: !visitor ? '#80C32D' : 'transparent'}}*/}
                                                {/*    onClick={() => {*/}
                                                {/*        setVisitor(false)*/}
                                                {/*        setBoothPreference(boothPackages.premium)*/}
                                                {/*    }}*/}
                                                {/*/>*/}
                                                <Button
                                                    text={t("visitorBtn")}
                                                    type="successTransparent"
                                                    className="mt-4"
                                                    style={{backgroundColor: visitor ? '#80C32D' : 'transparent'}}
                                                    onClick={() => {
                                                        setVisitor(true)
                                                        setBoothPreference(-1)
                                                    }}
                                                />
                                            </div>
                                        </div>
                                        <form className="my-4">
                                            <div className="row">
                                                <div className="col-md-4 px-3 mb-3">
                                                    <input className="register-input-modal w-100 px-3 py-2 mb-2"
                                                           ref={registerForm} name="firstName"
                                                           onChange={e => setRegisterValue('firstName', e.currentTarget.value)}
                                                           placeholder={t('firstNameField')} type='text'/>
                                                    {registerErrors.firstName &&
                                                    <div
                                                        className="text-danger text-left small mx-2">{registerErrors.firstName.message}</div>}
                                                </div>

                                                <div className="col-md-4 px-3 mb-3">
                                                    <input className="register-input-modal w-100 px-3 py-2 mb-2"
                                                           ref={registerForm} name="lastName"
                                                           onChange={e => setRegisterValue('lastName', e.currentTarget.value)}
                                                           placeholder={t('lastNameField')}
                                                           type='text'/>
                                                    {registerErrors.lastName &&
                                                    <div
                                                        className="text-danger text-left small mx-2">{registerErrors.lastName.message}</div>}
                                                </div>

                                                <div className="col-md-4 px-3 mb-3">
                                                    <input className="register-input-modal w-100 px-3 py-2 mb-2"
                                                           ref={registerForm} name="userName"
                                                           onChange={e => setRegisterValue('userName', e.currentTarget.value)}
                                                           placeholder={t('eMailField')}
                                                           type='text'/>
                                                    {registerErrors.userName &&
                                                    <div
                                                        className="text-danger text-left small mx-2">{registerErrors.userName.message}</div>}
                                                </div>

                                                <div className="col-md-4 px-3 mb-3">
                                                    <input className="register-input-modal w-100 px-3 py-2 mb-2"
                                                           ref={registerForm} name="password"
                                                           onChange={e => setRegisterValue('password', e.currentTarget.value)}
                                                           placeholder={t('passwordField')}
                                                           type='password'/>
                                                    {registerErrors.password &&
                                                    <div
                                                        className="text-danger text-left small mx-2">{registerErrors.password.message}</div>}
                                                </div>

                                                <div className="col-md-4 px-3 mb-3">
                                                    <input className="register-input-modal w-100 px-3 py-2 mb-2"
                                                           ref={registerForm}
                                                           name="confirmPassword"
                                                           onChange={e => setRegisterValue('confirmPassword', e.currentTarget.value)}
                                                           placeholder={t('confirmPasswordField')} type='password'/>
                                                    {registerErrors.confirmPassword &&
                                                    <div
                                                        className="text-danger text-left small mx-2">{registerErrors.confirmPassword.message}</div>}
                                                </div>

                                                <div className="col-md-4 px-3 mb-3">
                                                    <input className="register-input-modal w-100 px-3 py-2 mb-2"
                                                           ref={registerForm} name="companyName"
                                                           onChange={e => setRegisterValue('companyName', e.currentTarget.value)}
                                                           placeholder={t('companyNameField')} type='text'/>
                                                    {registerErrors.companyName &&
                                                    <div
                                                        className="text-danger text-left small mx-2">{registerErrors.companyName.message}</div>}
                                                </div>

                                                <div className="col-md-4 px-3 mb-3">
                                                    <input className="register-input-modal w-100 px-3 py-2 mb-2"
                                                           ref={registerForm} name="phoneNumber"
                                                           onChange={e => setRegisterValue('phoneNumber', e.currentTarget.value)}
                                                           placeholder={t('phoneNumberField')} type='text'/>
                                                    {registerErrors.phoneNumber &&
                                                    <div
                                                        className="text-danger text-left small mx-2">{registerErrors.phoneNumber.message}</div>}
                                                </div>

                                                <div className="col-md-4 px-3 mb-3">
                                                    <select className="register-input-modal w-100 px-3 py-2 mb-2"
                                                            ref={registerForm} name="countryId"
                                                            onChange={e => setRegisterValue('countryId', e.currentTarget.value)}>
                                                        {countries.map((item: any) => (
                                                            <option value={item.id} key={item.id}>{item.name}</option>
                                                        ))}
                                                    </select>
                                                    {registerErrors.countryId &&
                                                    <div
                                                        className="text-danger text-left small mx-2">{registerErrors.countryId.message}</div>}
                                                </div>

                                                <div className="col-md-4 px-3 mb-3">
                                                    <input className="register-input-modal w-100 px-3 py-2 mb-2"
                                                           ref={registerForm} name="city"
                                                           onChange={e => setRegisterValue('city', e.currentTarget.value)}
                                                           placeholder={t('cityField')}
                                                           type='text'/>
                                                    {registerErrors.city && <div
                                                        className="text-danger text-left small mx-2">{registerErrors.city.message}</div>}
                                                </div>
                                                {visitor &&
                                                <div className="col-md-4 px-3 mb-3">
                                                    <input className="register-input-modal w-100 px-3 py-2 mb-2"
                                                           ref={registerForm} name="numbeEmployees"
                                                           onChange={e => setRegisterValue('numbeEmployees', e.currentTarget.value)}
                                                           placeholder={t('numberOfEmployeesField')} type='text'/>
                                                    {registerErrors.numbeEmployees &&
                                                    <div
                                                        className="text-danger text-left small mx-2">{registerErrors.numbeEmployees.message}</div>}
                                                </div>}
                                                {visitor &&
                                                <div className="col-md-4 px-3 mb-3">
                                                    <input className="register-input-modal w-100 px-3 py-2 mb-2"
                                                           ref={registerForm} name="jobPostion"
                                                           onChange={e => setRegisterValue('jobPostion', e.currentTarget.value)}
                                                           placeholder={t('jobPositionField')} type='text'/>
                                                    {registerErrors.jobPostion &&
                                                    <div
                                                        className="text-danger text-left small mx-2">{registerErrors.jobPostion.message}</div>}
                                                </div>}
                                            </div>

                                            <div className="text-center text-md-left">
                                                <label>
                                                    <input name="GDPRText" type="checkbox" className="mr-2"
                                                           ref={registerForm}
                                                           onChange={e => setRegisterValue('GDPRText', e.currentTarget.checked)}/>
                                                    {t('GDPRText')}
                                                    {registerErrors.GDPRText && <div
                                                        className="text-danger text-left small">{registerErrors.GDPRText.message}</div>}
                                                </label>
                                            </div>
                                            <div className="d-flex justify-content-center pt-4">
                                                <Button
                                                    text="REGISTER"
                                                    className="border-0 text-white text-center font-weight-bold"
                                                    style={{padding: '10px 36px', background: '#a88b6b'}}
                                                    onClick={handleSubmitRegister(handleRegisterApi)}
                                                />
                                            </div>
                                        </form>
                                        <div className="text-center">
                                            <img
                                                className="w-100 mb-2" style={{maxWidth: 250, marginTop: '10px'}}
                                                src={require('../../assets/images/klubi-logo.png')}
                                            />
                                        </div>
                                    </>}
                                </ModalBody>
                            </Modal>
                        </div>

                        <div>
                            <FacebookLogin
                                appId="386505719335609"
                                autoLoad={false}
                                fields="name,email,picture"
                                callback={responseFacebook}
                                cssClass="py-2 font-weight-normal w-100 border-0 mb-2 mb-sm-0 mr-2 text-white fb"
                                textButton="Facebook"
                            />
                            <LinkedIn
                                clientId="77jjzevgq7td2w"
                                onFailure={handleFailure}
                                onSuccess={handleSuccess}
                                redirectUri={`https://${currentUrl}/linkedin`}
                                renderElement={({onClick, disabled}) => (
                                    <Button
                                        onClick={onClick}
                                        text={t('loginLinkedIn')}
                                        type="primary"
                                        className="py-2 font-weight-normal w-100 border-0"
                                        style={{maxWidth: '170px', background: '#0e76a9'}}
                                    />
                                )}
                            />
                        </div>
                        {/* <p style={{color:'darkgray'}} className="small mt-5">{t('loginViaSocial')}</p>

            <div>
              <button 
                className="py-2 font-weight-normal w-100 border-0 mb-2 mb-sm-0 mr-2 text-white fb">
                  Facebook
              </button>

              <Button
                // onClick={onClick}
                text={t('loginLinkedIn')}
                type="primary"
                className="py-2 font-weight-normal w-100 border-0"
                style={{ maxWidth: '170px', background:'#0e76a9'}}
              />
            </div> */}

                        {errorMessage &&
                        <Alert color="danger" className="w-100 mx-auto mt-4 mb-0" style={{maxWidth: '350px'}}>
                            {errorMessage}
                        </Alert>}

                        <img
                            className="w-100 mb-2" style={{maxWidth: 250, marginTop: '70px'}}
                            src={require('../../assets/images/klubi-logo.png')}
                        />
                    </div>
                </Container>
            </div>
        </div>


    );
}

export default Login;